import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../../common/GridLayout";
import SubLotSubTabs from "./SubLotSubTabs";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../../../../gridLayoutCustomization/GridLayoutManager";
const SubLotSearchFormResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const childRef = useRef();
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "dc96adca-c885-497d-81b8-06753eff86a5";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
        }
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="sublotCode" caption="Sublot"  />
                <Column dataField="description1" caption="Description 1"  />
                <Column dataField="description2" caption="Description 2"  />
                <Column dataField="lot" caption="Lot" />
                <Column dataField="itemCode" caption="Item"  />
                <Column dataField="customerId" caption="Customer" />
                <Column dataField="customerName" caption="Customer Name"  />
                <Column dataField="available" dataType="number" caption="Available" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="creationDateTime" caption="Creation Date Time" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="creationUserId" caption="Creation User ID" visible={false} />
                <Column dataField="lastUpdateDateTime" caption="Last Update Date Time" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="lastUpdateUserId" caption="Last Update User ID" visible={false} />
                <Column dataField="sublotUnitUOMFlag" caption="Sublot Unit UOM Flag" visible={false} />
                <Column dataField="sublotUnitUOMDefault" caption="Sublot Unit UOM Default" visible={false} />
                <Column dataField="inventoryUnitUOM" caption="Inventory Unit UOM" visible={false} />
                <Column dataField="piecesPerUnitUOM" caption="Pieces Per Unit UOM" visible={false} />
                <Column dataField="unitsPerPackageUOM" caption="Units Per Package UOM" visible={false} />
                <Column dataField="packagesPerShippingUnitUOM" caption="Packages Per Shipping Unit UOM" visible={false} />
                <Column dataField="packagesPerShippingUnitQty" caption="Packages Per Shipping Unit Qty" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="unitVolumeUOM" caption="Unit Volume UOM" visible={false} />
                <Column dataField="unitAreaUOM" caption="Unit Area UOM" visible={false} />
                <Column dataField="unitValueUOM" caption="Unit Value UOM" visible={false} />
                <Column dataField="netWeightUOM" caption="Net Weight UOM" visible={false} />
                <Column dataField="grossWeightUOM" caption="Gross Weight UOM" visible={false} />
                <Column dataField="diffDays" caption="Difference Days" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 0,
                    useGrouping: true
                }} visible={false} />
               
                <Column dataField="status" caption="Status" visible={false} />
                <Column dataField="comment" caption="Comment" visible={false} />
                <Column dataField="sublotSizeCode" caption="Sublot Size Code" visible={false} />
                <Column dataField="sublotProjectionCode" caption="Sublot Projection Code" visible={false} />
                <Column dataField="sublotUnitUomFlag" caption="Sublot Unit UOM Flag" visible={false} />
                <Column dataField="sublotUnitUomDefault" caption="Sublot Unit UOM Default" visible={false} />
                <Column dataField="sublotUnitsPerItemUnit" caption="Sublot Units Per Item Unit" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="netWeight" caption="Net Weight" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="grossWeight" caption="Gross Weight" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="unitPrice" caption="Unit Price" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="userDefinedCode1" caption="Code 1" visible={false} />
                <Column dataField="userDefinedCode2" caption="Code 2" visible={false} />
                <Column dataField="userDefinedCode3" caption="Code 3" visible={false} />
                <Column dataField="userDefinedCode4" caption="Code 4" visible={false} />
                <Column dataField="userDefinedCode5" caption="Code 5" visible={false} />
                <Column dataField="userDefinedCode6" caption="Code 6" visible={false} />
                <Column dataField="userDefinedCode7" caption="Code 7" visible={false} />
                <Column dataField="userDefinedCode8" caption="Code 8" visible={false} />
                <Column dataField="userDefinedCode9" caption="Code 9" visible={false} />
                <Column dataField="userDefinedCode10" caption="Code 10" visible={false} />
                <Column dataField="userDefinedReference1" caption="Reference 1" visible={false} />
                <Column dataField="userDefinedReference2" caption="Reference 2" visible={false} />
                <Column dataField="userDefinedReference3" caption="Reference 3" visible={false} />
                <Column dataField="userDefinedReference4" caption="Reference 4" visible={false} />
                <Column dataField="userDefinedReference5" caption="Reference 5" visible={false} />
                <Column dataField="userDefinedReference6" caption="Reference 6" visible={false} />
                <Column dataField="userDefinedReference7" caption="Reference 7" visible={false} />
                <Column dataField="userDefinedReference8" caption="Reference 8" visible={false} />
                <Column dataField="userDefinedReference9" caption="Reference 9" visible={false} />
                <Column dataField="userDefinedReference10" caption="Reference 10" visible={false} />
                <Column dataField="userDefinedDate1" dataType="date" format="MM/dd/yyyy" caption="Date 1" visible={false} />
                <Column dataField="userDefinedDate2" dataType="date" format="MM/dd/yyyy" caption="Date 2" visible={false} />
                <Column dataField="userDefinedDate3" dataType="date" format="MM/dd/yyyy" caption="Date 3" visible={false} />
                <Column dataField="userDefinedDate4" dataType="date" format="MM/dd/yyyy" caption="Date 4" visible={false} />
                <Column dataField="userDefinedDate5" dataType="date" format="MM/dd/yyyy" caption="Date 5" visible={false} />
                <Column dataField="userDefinedDate6" dataType="date" format="MM/dd/yyyy" caption="Date 6" visible={false} />
                <Column dataField="userDefinedDate7" dataType="date" format="MM/dd/yyyy" caption="Date 7" visible={false} />
                <Column dataField="userDefinedDate8" dataType="date" format="MM/dd/yyyy" caption="Date 8" visible={false} />
                <Column dataField="userDefinedDate9" dataType="date" format="MM/dd/yyyy" caption="Date 9" visible={false} />
                <Column dataField="userDefinedDate10" dataType="date" format="MM/dd/yyyy" caption="Date 10" visible={false} />
                <Column dataField="userDefinedQuantity1" dataType="number" caption="Quantity 1" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity2" dataType="number" caption="Quantity 2" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity3" dataType="number" caption="Quantity 3" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity4" dataType="number" caption="Quantity 4" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity5" dataType="number" caption="Quantity 5" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity6" dataType="number" caption="Quantity 6" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity7" dataType="number" caption="Quantity 7" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity8" dataType="number" caption="Quantity 8" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity9" dataType="number" caption="Quantity 9" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity10" dataType="number" caption="Quantity 10" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="dateIntroduced" dataType="date" format="MM/dd/yyyy" caption="Date Introduced" visible={false} />
                <Column dataField="dateAvailable" dataType="date" format="MM/dd/yyyy" caption="Date Available" visible={false} />
                <Column dataField="dateExpiration" dataType="date" format="MM/dd/yyyy" caption="Date Expiration" visible={false} />
                <Column dataField="inventoryUnitUom" caption="Inventory Unit UOM" visible={false} />
                <Column dataField="piecesPerUnitUom" caption="Pieces Per Unit UOM" visible={false} />
                <Column dataField="piecesPerUnitQuantity" dataType="number" caption="Pieces Per Unit Quantity" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="unitsPerPackageUom" caption="Units Per Package UOM" visible={false} />
                <Column dataField="unitsPerPackageQuantity" dataType="number" caption="Units Per Package Quantity" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="packagesPerShippingUnitUom" caption="Packages Per Shipping Unit UOM" visible={false} />
                <Column dataField="unitVolumeQuantity" dataType="number" caption="Unit Volume Quantity" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="unitAreaQuantity" dataType="number" caption="Unit Area Quantity" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="unitValueQuantity" dataType="number" caption="Unit Value Quantity" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="onHand" dataType="number" caption="On Hand" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="inOrdered" dataType="number" caption="In Ordered" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="outOrdered" dataType="number" caption="Out Ordered" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="inReceiving" dataType="number" caption="In Receiving" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="outShipped" dataType="number" caption="Out Shipped" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="inBackorder" dataType="number" caption="In Backorder" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="outBackorder" dataType="number" caption="Out Backorder" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="inUnavailable" dataType="number" caption="In Unavailable" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="outUnavailable" dataType="number" caption="Out Unavailable" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="inFuture" dataType="number" caption="In Future" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="outFuture" dataType="number" caption="Out Future" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
               
                <Column dataField="netAvailable" dataType="number" caption="Net Available" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="storageBillingStartDate" dataType="date" format="MM/dd/yyyy" caption="Storage Billing Start Date" visible={false} />
                <Column dataField="storageBillingEndDate" dataType="date" format="MM/dd/yyyy" caption="Storage Billing End Date" visible={false} />
                <Column dataField="popupMessage" caption="Popup Message" visible={false} />
                <Column dataField="size1" dataType="number" caption="Size 1" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="size2" dataType="number" caption="Size 2" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="storageBilledDateLast" dataType="date" format="MM/dd/yyyy" caption="Storage Billed Date Last" visible={false} />
                <Column dataField="storageBilledDateNext" dataType="date" format="MM/dd/yyyy" caption="Storage Billed Date Next" visible={false} />
                <Column dataField="alternateId" caption="Alternate ID" visible={false} />
                <Column dataField="inTransactionNumber" caption="In Transaction Number" visible={false} />
                <Column dataField="prevStorageBilledDateLast" dataType="date" format="MM/dd/yyyy" caption="Prev Storage Billed Date Last" visible={false} />
                <Column dataField="prevStorageBilledDateNext" dataType="date" format="MM/dd/yyyy" caption="Prev Storage Billed Date Next" visible={false} />
                <Column dataField="recurringStorage" caption="Recurring Storage" visible={false} />
                <Column dataField="packagesPerShippingUnitQuantity" dataType="number" caption="Packages Per Shipping Unit Quantity" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="unitVolumeUom" caption="Unit Volume UOM" visible={false} />
                <Column dataField="unitAreaUom" caption="Unit Area UOM" visible={false} />
                <Column dataField="unitValueUom" caption="Unit Value UOM" visible={false} />
                <Column dataField="netWeightUom" caption="Net Weight UOM" visible={false} />
                <Column dataField="grossWeightUom" caption="Gross Weight UOM" visible={false} />
               
                <Column dataField="itemDescription1" caption="Item Description 1" visible={false} />
                <Column dataField="itemDescription2" caption="Item Description 2" visible={false} />
                <Column dataField="itemStatus" caption="Item Status" visible={false} />
                <Column dataField="itemClass" caption="Item Class" visible={false} />
                <Column dataField="itemSubclass" caption="Item Subclass" visible={false} />
                <Column dataField="lotCode" caption="Lot Code" visible={false} />
                <Column dataField="lotDescription1" caption="Lot Description 1" visible={false} />
                <Column dataField="lotDescription2" caption="Lot Description 2" visible={false} />
                <Column dataField="lotStatus" caption="Lot Status" visible={false} />
                <Column dataField="lotClass" caption="Lot Class" visible={false} />
                <Column dataField="lotSubclass" caption="Lot Subclass" visible={false} />
               
                <Column dataField="customerAddress1" caption="Customer Address 1" visible={false} />
                <Column dataField="customerAddress2" caption="Customer Address 2" visible={false} />
                <Column dataField="customerCity" caption="Customer City" visible={false} />
                <Column dataField="customerState" caption="Customer State" visible={false} />
                <Column dataField="customerZip" caption="Customer Zip" visible={false} />
                <Column dataField="customerCountry" caption="Customer Country" visible={false} />
                <Column dataField="customerPhone" caption="Customer Phone" visible={false} />
                <Column dataField="customerFax" caption="Customer Fax" visible={false} />
                <Column dataField="customerEmail" caption="Customer Email" visible={false} />
                <Column dataField="consigneeId" caption="Consignee ID" visible={false} />
                <Column dataField="consigneeName" caption="Consignee Name" visible={false} />
                <Toolbar>

                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <SubLotSubTabs ref={childRef} accessToken={accessToken} />
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(SubLotSearchFormResult);